import React from "react";
import { useNavigate } from "react-router";
import {
  Box,
  Button,
  Container,
  Paper,
  Typography,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { MOCK_ORDER_REF } from "./constants";
import { useThemeColor } from "../hooks/useThemeColor";

export default function Success({ maskedPhone, orderReference }) {
  const navigate = useNavigate();
  const { themeColor } = useThemeColor();
  const primaryColor = themeColor || "#162A5C";
  const displayRef = orderReference ?? MOCK_ORDER_REF;

  return (
    <Container maxWidth="sm" className="pay-at-table-step pay-at-table-success" sx={{ py: 1 }}>
      <Paper
        elevation={2}
        sx={{ p: { xs: 2.5, sm: 4 }, borderRadius: 2, textAlign: "center" }}
        className="pay-at-table-card"
      >
        <Box className="pay-at-table-success-icon" sx={{ mb: 2 }}>
          <CheckCircleOutlineIcon
            sx={{
              fontSize: 80,
              color: primaryColor,
              stroke: primaryColor,
              strokeWidth: 1.5,
            }}
          />
        </Box>
        <Typography variant="h5" fontWeight={700} gutterBottom color="text.primary">
          Payment Successful!
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
          Your order has been paid.
        </Typography>
        {maskedPhone && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Receipt sent to {maskedPhone}
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Order reference #{displayRef}
        </Typography>
        <Button
          variant="outlined"
          size="large"
          onClick={() => navigate("/")}
          sx={{
            mt: 3,
            borderColor: "grey.400",
            color: "text.primary",
            "&:hover": {
              borderColor: primaryColor,
              color: primaryColor,
              bgcolor: "action.hover",
            },
          }}
        >
          Done
        </Button>
      </Paper>
    </Container>
  );
}
